import { pxToRem } from '@/Client/Styles/pxToRem';
import { css } from '@emotion/react';
import { formatCurrency, REACT_PRINT_STYLES, truncateNotesText } from '@kaiizen/kai-reports';
import { useState } from 'react';
import { useScopePrintPreviewContext } from './ScopePrintPreviewContext';
import { SectionHeaderInlineActionDropdown } from './SectionHeaderInlineActionDropdown';

const HEADER_CONTAINER_STYLE = css`
  cursor: pointer;

  @media print {
    cursor: default;
  }
`;

const HOVERED_HEADER_STYLE = css`
  background-color: #f5f5f5 !important;

  @media print {
    background-color: transparent !important;
  }
`;

export const TradeHeader = ({
  tradeName,
  groupRoomArea,
  groupTotal,
  groupNotes,
  groupId,
}: {
  tradeName: string;
  groupRoomArea?: number;
  groupTotal?: number;
  groupNotes?: string[];
  groupId: string;
}) => {
  const { groupingMode, currentDropdown, setCurrentDropdown } = useScopePrintPreviewContext();
  const [isHovered, setIsHovered] = useState(false);

  const isDropdownOpen = currentDropdown?.groupId === groupId && currentDropdown?.taskId === undefined;

  const handleHeaderClick = () => {
    setCurrentDropdown(isDropdownOpen ? undefined : { groupId });
  };

  return (
    <>
      <div
        css={[HEADER_CONTAINER_STYLE, isHovered && HOVERED_HEADER_STYLE]}
        onClick={handleHeaderClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div css={REACT_PRINT_STYLES.rowBetween}>
          <div css={REACT_PRINT_STYLES.groupPageTitle}>
            <h1 css={REACT_PRINT_STYLES.h1}>{tradeName.charAt(0).toUpperCase() + tradeName.slice(1)}</h1>
            {groupingMode === 'group' && (
              <span style={{ fontSize: pxToRem(14) }}>
                - {groupRoomArea != null ? groupRoomArea : '0'} sqft
              </span>
            )}
          </div>
          <div css={REACT_PRINT_STYLES.bold} style={{ fontSize: pxToRem(16) }}>
            Group Amount: <span>{formatCurrency(groupTotal || 0)}</span>
          </div>
        </div>
        {groupNotes && groupNotes.length > 0 && (
          <div style={{ marginTop: '8px', marginBottom: '16px' }}>
            <strong>Group Note:</strong>
            {truncateNotesText(groupNotes)}
          </div>
        )}
      </div>
      <SectionHeaderInlineActionDropdown
        groupId={groupId}
      />
    </>
  );
};
